<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
/*
const brandcolors = Array(
Array("#E5C049","#3d4243","#f0f0f1"),
Array("#EBB0B8","#f0f0f1","#7e868a"),
Array("#f0f0f1","#3F425D","#ca4286"),
Array("#ca4286","#3d4243","#00aec5"),
Array("#3d4243","#00aec5","#f0f0f1"),
Array("#c8ccca","#ea6f46","#f0f0f1"),
Array("#00aec5","#ca4286","#f0f0f1"),
Array("#3F425D","#ca4286","#f0f0f1")); */
const brandcolors = Array(
Array("#F3F3F3","#13256E","#D42AA3","#D42AA3","#D42AA3"),
Array("#000","#1EB5C7","#fff","#fff","#1EB5C7")
);

var bodyStyles = document.body.style;
var colorSet = 0; 
var prevColorSet = null;
var prevPrevColorSet = null;
var prevPrevPrevColorSet = null;


bodyStyles.setProperty('--logocolor', brandcolors[0][1]);
bodyStyles.setProperty('--iamcolor', brandcolors[0][2]);
bodyStyles.setProperty('--iambackcolor', brandcolors[0][3]);
bodyStyles.setProperty('--secbackcolor', brandcolors[0][4]);
bodyStyles.setProperty('--backcolor', brandcolors[0][0]);

/* IAM SYNC: avisa a fotos y productos del estado inicial (0 = claro) */
document.body.setAttribute('data-iam-dark', 'false');


setTimeout(function () {
changeColor();
}, 8000);

function changeColor() {
var prevPrevPrevPrevColorSet = prevPrevPrevColorSet;
prevPrevPrevColorSet = prevPrevColorSet;
prevPrevColorSet = prevColorSet;
prevColorSet = colorSet;
colorSet = Math.floor(Math.random() * 2);
if (prevColorSet !== colorSet && prevPrevColorSet !== colorSet && prevPrevPrevColorSet !== colorSet) {
bodyStyles.setProperty('--logocolor', brandcolors[colorSet][1]);
bodyStyles.setProperty('--iamcolor', brandcolors[colorSet][2]);
bodyStyles.setProperty('--iambackcolor', brandcolors[colorSet][3]);
bodyStyles.setProperty('--secbackcolor', brandcolors[colorSet][4]);
bodyStyles.setProperty('--backcolor', brandcolors[colorSet][0]);

/* IAM SYNC: en el MISMO instante que cambian los colores del header,
   avisa a fotos y productos. Set 1 = negro, set 0 = claro. */
document.body.setAttribute('data-iam-dark', colorSet === 1 ? 'true' : 'false');

setTimeout(function () {
changeColor();
    }, 8000);
  } else {
changeColor();
  }
}